import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext({
  items:          [],
  addToCart:      () => {},
  removeFromCart: () => {},
  clearCart:      () => {},
  isInCart:       () => false,
});

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('madjeo_cart')) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('madjeo_cart', JSON.stringify(items));
  }, [items]);

  const addToCart = (point, price) => {
    setItems(prev => {
      if (prev.find(i => i.id === point.id)) return prev;
      const [lng, lat] = point.geometry?.coordinates ?? [null, null];
      return [...prev, {
        id:         point.id,
        nom:        point.properties?.nom || `Point #${point.id}`,
        has_pdf:    point.properties?.has_pdf || false,
        lat,
        lng,
        amount_mga: price?.amount_mga ?? 2000,
        amount_eur: price?.amount_eur ?? 0.50,
      }];
    });
  };

  const removeFromCart = (id) => setItems(prev => prev.filter(i => i.id !== id));
  const clearCart      = ()  => setItems([]);
  const isInCart       = (id) => items.some(i => i.id === id);

  return (
    <CartContext.Provider value={{ items, addToCart, removeFromCart, clearCart, isInCart }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
